import { ButtonBase, Tooltip, useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import withWidth, {
  isWidthDown,
  isWidthUp,
} from '@mui/material/Hidden/withWidth'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import { observer } from 'mobx-react'
import React, { useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router'
import { isLooker } from 'src/services/AccountService'
import lupe from '../../assets/images/common/lupe.svg'
import roundedPlus from '../../assets/images/common/roundedPlus.svg'
import selectArrow from '../../assets/images/common/selectArrow.svg'
import { isDealer } from '../../services/AccountService'
import commonStyles from '../../styles/commonStyles'
import useScrollDirectionDown from '../../utils/hooks/useScrollDirectionDown'
import { getStyles } from '../../utils/utils/commonUtils'
import OrderValue from '../../views/RequestsManagement/components/NewRequestFilters/components/OrderValue'
import mobileRequestsManagementStyles from '../../views/RequestsManagement/styles/mobileRequestManagmentStyles'
import Chips from '../Chips/Chips'
import FiltersForm from '../FiltersForm/FiltersForm'
import DownloadButton from './components/DownLoadButton'

function NewFilters({
  totalCollectionLength,
  filtersStore,
  filtersData,
  onSearch,
  onClear,
  setChip,
  filtersContainerHeight,
  title,
  actionButtonProps,
  width,
  filterRowStyles = {},
  scrollIsAlreadyLocked,
  downloadRequestsListPDF,
  selectOrderCollection,
  gray,
  selectOrdersStore,
  selectedOrders,
  filtersForm,
  disableProgress,
  isPinkBtn,
  isAgreement,
  paginationStore,
  checkboxStore,
  background,
}) {
  const theme = useTheme()
  const btnRef = useRef(null)
  const [isFiltersOpen, setIsFiltersOpen] = useState(false)
  const classes = {
    ...getStyles(commonStyles),
    ...getStyles(mobileRequestsManagementStyles),
  }
  const location = useLocation()
  const currentPath = location.pathname
  const handleClear = async () => {
    if (onClear) {
      onClear()
    } else {
      filtersStore?.clear()
      await onSearch()
    }
  }
  // показывает и скрывает кнопку создания заявки на мобильных в зависимости от направления скролла
  const directionDown = useScrollDirectionDown()

  useEffect(() => {
    if (btnRef.current) {
      btnRef.current.style = directionDown ? 'bottom: -100px' : 'bottom: 77px'
    }
  }, [directionDown])

  const isDonloadBtnDisable =
    !checkboxStore?.allIds.length ||
    (checkboxStore?.allIds.length && !checkboxStore?.selectedIds.length)

  return (
    <Box
      sx={{
        ...((actionButtonProps && !isLooker()) ||
        (actionButtonProps &&
          !isLooker() &&
          actionButtonProps?.name !== 'Создать заявку')
          ? {
              display: 'grid',
              gap: '20px',
              gridTemplateColumns: '1fr 281px',
            }
          : {}),
        ...(isDealer()
          ? {
              ...classes.searchBlock,
            }
          : {
              [theme.breakpoints.down('sm', width)]: {
                marginTop: '16px',
                gridTemplateColumns: '1fr 60px',
                gap: '12px',
              },
            }),
      }}
    >
      <ButtonBase
        id={'searchBox'}
        sx={{
          ...classes.searchBox,
          ...filterRowStyles,
          zIndex: isFiltersOpen ? 1001 : 999,
          background: gray
            ? isFiltersOpen
              ? null
              : (background ?? 'rgba(224, 223, 223, 1)')
            : null,
        }}
        disableTouchRipple={true}
      >
        <OrderValue
          value={totalCollectionLength}
          active={isFiltersOpen}
          title={title}
        />
        {isDealer() && isWidthDown('sm', width) ? (
          <Box></Box>
        ) : (
          <Box
            sx={{
              overflowY: 'auto',
              padding: '0 16px',
              height: '100%',
              cursor: 'pointer',
            }}
            onClick={() => setIsFiltersOpen((prevState) => !prevState)}
          >
            {setChip ? (
              <Chips
                setChip={(params) => setChip(params, true)}
                filters={filtersStore?.selectedFilters}
              />
            ) : null}
          </Box>
        )}

        <IconButton
          onClick={() => setIsFiltersOpen((prevState) => !prevState)}
          sx={classes.filterOpenBtn}
        >
          {isFiltersOpen ? (
            <img
              alt={'arrow up'}
              src={selectArrow}
              style={{
                transform: 'rotate(180deg)',
                transition: '0.5s all',
              }}
            />
          ) : (
            <Box sx={classes.lupeIconWrapper}>
              {isDealer() && !!filtersStore?.selectedFilters.length && (
                <Box sx={classes.haveFiltersDot}></Box>
              )}
              <img alt={'lupe'} src={lupe} />
            </Box>
          )}
        </IconButton>

        {filtersForm ? (
          filtersForm
        ) : (
          <FiltersForm
            opened={isFiltersOpen}
            filtersStore={filtersStore}
            onClear={handleClear}
            onSearch={onSearch}
            onClose={() => setIsFiltersOpen(false)}
            filtersData={filtersData}
            setChip={setChip}
            filtersContainerHeight={filtersContainerHeight}
            scrollIsAlreadyLocked={scrollIsAlreadyLocked}
            width={width}
            disableProgress={disableProgress}
          />
        )}
      </ButtonBase>
      <Box
        sx={{
          display: isDealer() && currentPath === '/requests' ? 'flex' : null,
          gap: isDealer() && currentPath === '/requests' ? '10px' : null,
        }}
      >
        {isDealer() &&
          currentPath === '/requests' &&
          actionButtonProps?.name !== 'Детали отчета' && (
            <DownloadButton
              disabled={isDonloadBtnDisable}
              onClick={downloadRequestsListPDF}
              paginationStore={paginationStore}
              checkboxStore={checkboxStore}
            />
          )}
        {/* Todo: refactor conditions */}
        {((actionButtonProps && !isLooker()) ||
          (actionButtonProps &&
            !isLooker() &&
            actionButtonProps?.name !== 'Создать заявку')) && (
          <Tooltip
            title={actionButtonProps?.tooltip}
            placement={actionButtonProps?.tooltipPlacement ?? 'top-start'}
            disableHoverListener={actionButtonProps?.tooltipDisabled}
            disableInteractive={actionButtonProps?.tooltipDisabled}
            PopperProps={{
              sx: {
                textAlign: 'center',
                '&>div': { maxWidth: '250px', width: 'max-content' },
              },
            }}
          >
            <Box sx={{ flexGrow: 1 }}>
              <Button
                variant={'contained'}
                id={'createRequestButton'}
                color={'primary'}
                onClick={actionButtonProps?.onClick}
                sx={
                  isDealer()
                    ? {
                        ...classes.buttonActive,
                        borderRadius: '4px',
                        width: '100%',
                        maxWidth: '281px',
                        background:
                          isPinkBtn ||
                          (gray && checkboxStore?.selectedIds.length)
                            ? 'rgba(224, 23, 23, 0.6)'
                            : null,
                        '&:hover': {
                          background:
                            isPinkBtn ||
                            (gray && checkboxStore?.selectedIds.length)
                              ? 'rgba(224, 23, 23, 0.5)'
                              : null,
                        },
                        gridColumn: 2,
                        ...classes.createRequestDesctopBtn,
                      }
                    : {
                        ...classes.buttonActive,
                        borderRadius: '4px',
                        width: '100%',
                        maxWidth: '281px',
                        gridColumn: 2,
                        [theme.breakpoints.down('sm', width)]: {
                          paddingX: '8px',
                          minWidth: '60px',
                        },
                      }
                }
                disabled={actionButtonProps?.disabled}
                startIcon={<img alt={''} src={actionButtonProps?.icon} />}
              >
                {isWidthUp('sm', width) && (
                  <Box pl={1.5}>
                    <Typography
                      variant={'h6'}
                      sx={{
                        textTransform: 'uppercase',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {actionButtonProps?.name}
                    </Typography>
                  </Box>
                )}
              </Button>
            </Box>
          </Tooltip>
        )}

        {actionButtonProps && !isLooker() && isDealer() && !isAgreement && (
          <Button
            ref={btnRef}
            id='createRequestBtn'
            onClick={actionButtonProps.onClick}
            disabled={actionButtonProps.disabled}
            startIcon={<img alt={'add request'} src={roundedPlus} />}
            sx={{
              ...classes.buttonActive,
              ...classes.createRequestMobileBtn,
            }}
          />
        )}
        {isFiltersOpen ? (
          <Box
            sx={{
              position: 'fixed',
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
              background: 'rgba(0,0,0,0.4)',
              zIndex: 1000,
            }}
            onClick={() => setIsFiltersOpen(false)}
          />
        ) : null}
      </Box>
    </Box>
  )
}

export default withWidth()(observer(NewFilters))
